import React, { useState } from 'react';
import '../PIShell.css';

const PROVIDERS = [
  {
    id: 'quickbooks',
    name: 'QuickBooks Online',
    description: 'Pull P&L data and EBITDA metrics automatically from your QuickBooks company.',
    category: 'Financial',
    logoColor: '#2CA01C',
    logoInitial: 'QB',
  },
  {
    id: 'netsuite',
    name: 'NetSuite',
    description: 'Sync income statement and balance sheet data from NetSuite ERP.',
    category: 'Financial',
    logoColor: '#005F9E',
    logoInitial: 'NS',
  },
  {
    id: 'salesforce',
    name: 'Salesforce',
    description: 'Import closed-won pipeline and revenue data from your Salesforce CRM.',
    category: 'CRM',
    logoColor: '#00A1E0',
    logoInitial: 'SF',
  },
  {
    id: 'hubspot',
    name: 'HubSpot',
    description: 'Sync company records and deal pipeline from HubSpot CRM.',
    category: 'CRM',
    logoColor: '#FF7A59',
    logoInitial: 'HS',
  },
  {
    id: 'visible',
    name: 'Visible.vc',
    description: 'Pull LP updates and KPI metrics from your Visible.vc portfolio workspace.',
    category: 'Reporting',
    logoColor: '#6366F1',
    logoInitial: 'VV',
  },
];

export default function PIIntegrationsTab() {
  const [notified, setNotified] = useState({});

  const categories = [...new Set(PROVIDERS.map(p => p.category))];

  return (
    <div style={{ padding: '24px 28px' }}>
      <p style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
        Integrations are coming soon. Enter your data manually in each module until then.
      </p>

      {categories.map(cat => (
        <div key={cat} style={{ marginBottom: 28 }}>
          <h3 style={{ fontSize: 13, fontWeight: 600, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 14 }}>
            {cat}
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {PROVIDERS.filter(p => p.category === cat).map(provider => (
              <div key={provider.id} className="pi-card" style={{ padding: '16px 18px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 8, background: provider.logoColor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
                      {provider.logoInitial}
                    </div>
                    <div>
                      <div style={{ fontSize: 13.5, fontWeight: 600, color: '#1e293b' }}>{provider.name}</div>
                      <span style={{ background: '#f1f5f9', color: '#64748b', fontSize: 12, borderRadius: 999, padding: '3px 10px', display: 'inline-block', marginTop: 4 }}>
                        Coming Soon
                      </span>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: 12.5, color: '#64748b', lineHeight: 1.6, margin: '0 0 12px' }}>
                  {provider.description}
                </p>

                <div>
                  <button
                    className="pi-btn-ghost"
                    style={{ fontSize: 12 }}
                    onClick={() => setNotified(n => ({ ...n, [provider.id]: true }))}
                  >
                    Notify Me
                  </button>
                  {notified[provider.id] && (
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 8 }}>
                      Got it. We will notify you when this integration is available.
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Roadmap note */}
      <div className="pi-card" style={{ padding: '18px 20px', marginTop: 8 }}>
        <h4 style={{ fontSize: 14, fontWeight: 600, color: '#1e293b', margin: '0 0 8px' }}>
          Coming soon: Live accounting sync
        </h4>
        <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.65, margin: 0 }}>
          We are building a direct connection to QuickBooks Online and NetSuite that pulls working capital metrics
          and P&amp;L data automatically for each portfolio company. Enter your data manually in the Cash &amp; Tax
          module until then.
        </p>
      </div>
    </div>
  );
}
